import cx from "classnames";
import PropTypes from "prop-types";
import React, { createContext, useContext } from "react";

export const bem = (namespace) => {
  return (...tokens) => {
    let normalizedTokens = cx(tokens).split(/\s+/g);
    let block = normalizedTokens.find((token) => token.startsWith("__")) || "";
    normalizedTokens = normalizedTokens.map((token) =>
      token.startsWith("--")
        ? `${namespace}${block}${token}`
        : token.startsWith("__")
        ? null
        : token,
    );
    return cx(`${namespace}${block}`, normalizedTokens);
  };
};

export const useBEM = (namespace) => {
  if (!namespace) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    namespace = useContext(bemContext).namespace;
  }
  return bem(namespace);
};

export const bemContext = createContext({ namespace: null });

export const BEMProvider = bemContext.Provider;

export function BEM({ namespace, children: Children }) {
  return (
    <BEMProvider value={{ namespace }}>
      {typeof Children === "function" ? <Children /> : Children}
    </BEMProvider>
  );
}

BEM.propTypes = {
  namespace: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};
